// ===== CALCULADORA DE PLAZOS LEGALES DE COSTA RICA =====
// Basado en el Código Procesal Civil, Código Procesal Penal y Ley Orgánica del Poder Judicial

export const LegalDeadlines = {
    // Plazos del Código Procesal Civil
    civil: {
        'contestacion_demanda': { days: 8, tipo: 'hábiles', descripcion: 'Plazo para contestar demanda (Art. 434 CPC)' },
        'apelacion_sentencia': { days: 3, tipo: 'hábiles', descripcion: 'Plazo para apelar sentencia (Art. 592 CPC)' },
        'oposicion_medida_cautelar': { days: 3, tipo: 'hábiles', descripcion: 'Oposición a medida cautelar (Art. 241 CPC)' },
        'prueba_anticipada': { days: 6, tipo: 'hábiles', descripcion: 'Prueba anticipada (Art. 310 CPC)' },
        'excepciones_previas': { days: 5, tipo: 'hábiles', descripcion: 'Excepciones previas (Art. 295 CPC)' },
        'alegatos_conclusion': { days: 10, tipo: 'hábiles', descripcion: 'Alegatos de conclusión (Art. 378 CPC)' },
        'interposicion_recurso_casacion': { days: 15, tipo: 'hábiles', descripcion: 'Recurso de casación (Art. 598 CPC)' },
        'recurso_revocatoria': { days: 3, tipo: 'hábiles', descripcion: 'Recurso de revocatoria (Art. 155 CPC)' }
    },

    // Plazos del Código Procesal Penal
    penal: {
        'querella': { days: 3, tipo: 'hábiles', descripcion: 'Querella (Art. 17 CPP)' },
        'recurso_apelacion': { days: 3, tipo: 'hábiles', descripcion: 'Recurso de apelación (Art. 454 CPP)' },
        'recurso_casacion': { days: 10, tipo: 'hábiles', descripcion: 'Recurso de casación (Art. 469 CPP)' },
        'prision_preventiva_renovacion': { days: 90, tipo: 'calendario', descripcion: 'Renovación prisión preventiva (Art. 257 CPP)' }
    },

    // Plazos Laborales
    laboral: {
        'contestacion_demanda': { days: 5, tipo: 'hábiles', descripcion: 'Contestar demanda laboral (Art. 454 CPT)' },
        'apelacion': { days: 3, tipo: 'hábiles', descripcion: 'Apelación sentencia laboral (Art. 502 CPT)' },
        'recurso_casacion': { days: 8, tipo: 'hábiles', descripcion: 'Casación laboral (Art. 516 CPT)' }
    },

    // Plazos Constitucionales
    constitucional: {
        'recurso_amparo': { days: 30, tipo: 'hábiles', descripcion: 'Recurso de amparo (Art. 35 LJCA)' },
        'accion_inconstitucionalidad': { days: null, tipo: 'imprescriptible', descripcion: 'Acción de inconstitucionalidad' }
    }
};

// Días feriados de Costa Rica (2026)
export const CostaRicaHolidays2026 = [
    '2026-01-01', // Año Nuevo
    '2026-04-02', // Jueves Santo
    '2026-04-03', // Viernes Santo
    '2026-04-11', // Día de Juan Santamaría
    '2026-05-01', // Día del Trabajo
    '2026-07-25', // Anexión de Guanacaste
    '2026-08-02', // Día de la Virgen de los Ángeles
    '2026-08-15', // Día de la Madre
    '2026-09-15', // Independencia
    '2026-12-25'  // Navidad
];

/**
 * Calcula una fecha agregando días hábiles (excluyendo sábados, domingos y feriados)
 */
export function addBusinessDays(startDate, days, holidays = CostaRicaHolidays2026) {
    let currentDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
        currentDate.setDate(currentDate.getDate() + 1);

        const dayOfWeek = currentDate.getDay();
        const dateStr = currentDate.toISOString().split('T')[0];

        // Saltar fines de semana y feriados
        if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(dateStr)) {
            addedDays++;
        }
    }

    return currentDate;
}

/**
 * Calcula automáticamente plazos críticos basados en un evento inicial
 */
export function calculateCriticalDeadlines(evento, tipoMateria = 'civil') {
    const plazosMateria = LegalDeadlines[tipoMateria];
    if (!plazosMateria) return [];

    const fechaEvento = evento.date instanceof Date ? evento.date : new Date(evento.date.seconds * 1000);
    const plazosSugeridos = [];

    // Sugerir plazos según el tipo de evento
    if (evento.type === 'demanda' || evento.type === 'notificacion') {
        if (plazosMateria.contestacion_demanda) {
            const plazo = plazosMateria.contestacion_demanda;
            const fechaLimite = plazo.tipo === 'hábiles'
                ? addBusinessDays(fechaEvento, plazo.days)
                : new Date(fechaEvento.getTime() + plazo.days * 24 * 60 * 60 * 1000);

            plazosSugeridos.push({
                title: `Vencimiento: ${plazo.descripcion}`,
                type: 'plazo',
                date: fechaLimite,
                description: `Plazo fatal de ${plazo.days} días ${plazo.tipo} desde ${evento.title}`,
                color: '#dc2626',
                isFuture: fechaLimite > new Date(),
                isCertain: true,
                urgent: true,
                relatedTo: evento.id
            });
        }
    }

    if (evento.type === 'sentencia') {
        if (plazosMateria.apelacion_sentencia || plazosMateria.recurso_apelacion) {
            const plazo = plazosMateria.apelacion_sentencia || plazosMateria.recurso_apelacion;
            const fechaLimite = plazo.tipo === 'hábiles'
                ? addBusinessDays(fechaEvento, plazo.days)
                : new Date(fechaEvento.getTime() + plazo.days * 24 * 60 * 60 * 1000);

            plazosSugeridos.push({
                title: `Vencimiento: ${plazo.descripcion}`,
                type: 'plazo',
                date: fechaLimite,
                description: `Plazo fatal de ${plazo.days} días ${plazo.tipo} desde ${evento.title}`,
                color: '#dc2626',
                isFuture: fechaLimite > new Date(),
                isCertain: true,
                urgent: true,
                relatedTo: evento.id
            });
        }
    }

    return plazosSugeridos;
}

/**
 * Calcula el nivel de urgencia de un evento basado en días restantes
 */
export function calculateUrgencyLevel(eventDate) {
    const now = new Date();
    const diff = eventDate - now;
    const daysRemaining = Math.ceil(diff / (1000 * 60 * 60 * 24));

    if (daysRemaining < 0) return { level: 'vencido', color: '#991b1b', label: 'VENCIDO' };
    if (daysRemaining <= 1) return { level: 'critico', color: '#dc2626', label: 'CRÍTICO' };
    if (daysRemaining <= 3) return { level: 'urgente', color: '#f97316', label: 'URGENTE' };
    if (daysRemaining <= 7) return { level: 'proximo', color: '#facc15', label: 'PRÓXIMO' };
    return { level: 'normal', color: '#10b981', label: 'NORMAL' };
}

/**
 * Genera un reporte de análisis de riesgo del caso
 */
export function generateRiskAnalysis(events) {
    const now = new Date();
    const plazosVencidos = [];
    const plazosCriticos = [];
    const proximosEventos = [];

    events.forEach(event => {
        const eventDate = event.date instanceof Date ? event.date : new Date(event.date.seconds * 1000);
        const urgency = calculateUrgencyLevel(eventDate);

        if (event.type === 'plazo') {
            if (urgency.level === 'vencido') {
                plazosVencidos.push(event);
            } else if (urgency.level === 'critico' || urgency.level === 'urgente') {
                plazosCriticos.push(event);
            }
        }

        if (eventDate > now && eventDate < new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000)) {
            proximosEventos.push(event);
        }
    });

    return {
        plazosVencidos,
        plazosCriticos,
        proximosEventos,
        nivelRiesgo: plazosVencidos.length > 0 ? 'ALTO' : plazosCriticos.length > 0 ? 'MEDIO' : 'BAJO',
        alertas: [
            ...plazosVencidos.map(p => `⚠️ PLAZO VENCIDO: ${p.title}`),
            ...plazosCriticos.map(p => `🔥 PLAZO CRÍTICO: ${p.title}`)
        ]
    };
}
